import { render, staticRenderFns } from "./EditionPlanAlimentaire.vue?vue&type=template&id=08d7d5d8&scoped=true&"
import script from "./EditionPlanAlimentaire.vue?vue&type=script&lang=js&"
export * from "./EditionPlanAlimentaire.vue?vue&type=script&lang=js&"
import style0 from "./EditionPlanAlimentaire.vue?vue&type=style&index=0&id=08d7d5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7d5d8",
  null
  
)

export default component.exports